import dynamic from "next/dynamic";

export const DynamicPlayer = dynamic(
  () => import("@lottiefiles/react-lottie-player").then(module => module.Player),
  { ssr: false },
);
